module.exports = __webpack_public_path__ + "static/img/4.955630f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/preview/department/4.png
// module id = FtJs
// module chunks = 1